import { IApplicationState } from '../../types/redux';

export const selectIsPageLoaderVisible = (state: IApplicationState): boolean => {
  return state.loadingStatus.pageLoader;
};
